import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbLgpd } from 'app/abstract/full-pages/lgpd/lgpd.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LgpdService extends AbLgpd {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllLgpd(filter: AppFilter): Observable<any> {
    return this.get(`admin/lgpd/filter/${filter.encode()}`);
  }

  public salvarLgpd(entity) {
    return this.save("admin/lgpd/", entity);
  }

  public salvarLgpdAceite(entity): Promise<any> {
    return this.save("admin/lgpd_aceite/", entity).toPromise().catch();
  }

  public getLgpd(id) {
    return this.get("admin/lgpd/dto/", id);
  }

  public deleteLgpd(id) {
    return this.delete("admin/lgpd/", id);
  }

}
